import { TImageField, TLinkField, TSocialMediaFields, TStringField } from "../../../types/types";
import { TLightFooterFields, TLightFooterProps } from "../types/lightFooter.types";

export class LightFooterModel {
    private readonly fields?: TLightFooterFields;

    constructor(props: TLightFooterProps) {
        this.fields = props?.fields;
    }

    get list() {
        return Array.isArray(this.fields?.links) ? (this.fields?.links) : [];
    }

    get copyrightText(): TStringField | undefined {
        return this.fields?.copyrightText;
    }

    get link(): TLinkField | undefined {
        return this.fields?.logoLink;
    }

    get logoImage(): TImageField | undefined {
        return this.fields?.logoImage;
    }

    get mobileLogoImage(): TImageField | undefined {
        return this.fields?.mobileLogoImage;
    }

    get slogan(): TStringField | undefined {
        return this.fields?.slogan;
    }

    get socialLinks(): TSocialMediaFields | undefined {
        return this.fields?.socialLinks;
    }

    get isUnreleased(): boolean {
        return !!this.fields?.isComponentUnreleased;
    }
}